import { Box, Stack, Typography } from '@mui/material';

import { Button } from '@karehero/llama/components/atoms/Button/Button';

import { QUESTIONS } from '@/benefits-flow/screener/questions';
import QuestionField from '@/benefits-flow/screener/QuestionField';
import Screen from '@/karehero-app/explore/Screen';
import {
  PERSON,
  SEAM,
} from '@/karehero-app/explore/benefits-calculator/BenefitsCalculator.content';
import {
  Note,
  WorkingBanner,
} from '@/karehero-app/explore/benefits-calculator/Parts';

// Section H. Three answers to the one question the technical plan forces on us:
// the user has submitted something and we are not ready. Real-time is out of
// scope, so this is not avoidable, only designable.
//
// Presented as rivals rather than a sequence because it is a decision, and the
// trade is different for each. H2 is the one the rest of the page assumes.

const noop = () => undefined;

// Block and wait. Honest, and the one that makes the latency the user's problem.
export const H1Block = () => (
  <Screen title={SEAM.block.title} subtitle={SEAM.block.body}>
    <Stack sx={{ alignItems: 'flex-start' }} spacing={2}>
      <WorkingBanner label={SEAM.block.progress} />
      <Note
        title='Nothing else to do here'
        body='Every question after this one is waiting on the note being read.'
      />
    </Stack>
  </Screen>
);
H1Block.displayName = 'H1Block';

// Carry on. The taps cover the latency, which is only possible because the
// question set is small and pruned. The minimisation is what makes this work,
// not what stops it working.
export const H2CarryOn = () => (
  <Screen back>
    <Stack spacing={2}>
      <Box>
        <WorkingBanner label={SEAM.carryOn.banner} />
      </Box>
      <Typography variant='body2' color='text.secondary'>
        {SEAM.carryOn.body}
      </Typography>
      <QuestionField
        question={QUESTIONS['care-recipient-savings-held-in-bank-accounts']}
        recipientName={PERSON.name}
        value={undefined}
        onChange={noop}
      />
    </Stack>
  </Screen>
);
H2CarryOn.displayName = 'H2CarryOn';

export const H3Notify = () => (
  <Screen
    title={SEAM.notify.title}
    subtitle={SEAM.notify.body}
    footer={
      <Button ariaLabel={SEAM.notify.cta} isFullWidth>
        {SEAM.notify.cta}
      </Button>
    }
  >
    <Note
      title={SEAM.notify.push.title}
      icon='bell'
      body={SEAM.notify.push.body}
    />
  </Screen>
);
H3Notify.displayName = 'H3Notify';
